import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import PreLoginTemplate from "../Template/PreLoginTemplate";
import { Button, Divider, Grid, Container } from "@material-ui/core";
import { CitationDetailsCard, CardContent } from "../Card/CitationDetailsCard";
import Image from "../../assets/image/MC.png";
import Text from "../Text/Text";
import AppealCitationModal from "../Modals/citation/AppealCitationModal";
import AppealedCitationModal from "../Modals/citation/AppealedCitationModal";
import { getCitation } from "../../store/citationDetail/action";
import { useHistory, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { RouteService } from "../../services/route.service";
import { getCustomer } from "../../store/home/selector";
import { getConfig } from "../../services/environment";
import {
  getCitationDetailsPageEditorSelector,
  getProfileData,
} from "../../store/profile/selector";
import {
  getDriverCitationPDFStates,
  getDriverCitationPDFStatesUnpaid,
} from "../../store/citationDetailPDF/action";
import { DetailsSharp } from "@material-ui/icons";
import { getCitationDetailsPageEditorDataAction, getStates } from "../../store/profile/action";
import { getCitationAppealDays, getUserContextData } from "../../store/login/selector";
import moment from "moment";
import ImageViewer from "../Modals/citation/ImageViewer";
import { id } from "date-fns/locale";
import "./visitorpermit.css";
import { driverCreditCardValueList } from "../../store/citation/selector";
import { getCutationDurationDay } from "../../store/login/action";
const useStyles = makeStyles((theme) => ({
  content: {
    // boxShadow: "0px 0 1px 1px #ccc",
    borderRadius: "10px",
    //width: "100%",
    minHeight: "calc(100vh - 280px)",
    padding: "2%",
    marginBottom: "5rem",
  },
  half: {
    width: "50%",
  },
  spaceTop: {
    marginTop: 15,
  },
  row: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    marginTop: 15,
  },
  img: {
    width: "100%",
    height: 100,
  },
  pointer: {
    cursor: "pointer",
  },
  item: {
    padding: "1px !important",
  },
  bdrc: {
    borderRadius: "0px",
  },
  bgColor: {
    backgroundColor: "#20419a",
    color: "white",
  },
}));

const CitationDetailsPage = (props) => {
  const classes = useStyles();
  const params = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { customer } = params;
  const customerName = useSelector(getCustomer);
  const citationDetailState = useSelector((state) => state.citationDetailState);
  const citationDetailEditorData = useSelector(
    getCitationDetailsPageEditorSelector
  );
  const [isOpenAppealCitationModal, setIsOpenAppealCitationModal] =
    useState(false);
  const [isOpenAppealedCitationModal, setIsOpenAppealedCitationModal] =
    useState(false);
  const [appealCitationStatus, setAppealCitationStatus] = useState(false);
  const profileStore = useSelector(getProfileData);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedImage, SetSelectedImage] = useState();
  const[count,setCount]=useState(0)
  const userParams = useParams();
  const citationDurationData = useSelector(getCitationAppealDays);
  const credutCardValue = useSelector((state) => state?.driverCitationReducer?.driverCreditCardValue?.acceptedPaymentMethods);

  const citationDetailStateData = new Date(citationDetailState?.issueDate).toLocaleDateString();
  const citationDate = citationDurationData?.appealsDurationDays; 
 const citationDurationDays= moment(citationDetailStateData).add(citationDate, 'days').format('MM/DD/YY')

  const dd = new Date();
  const compareDurationDate = moment(citationDurationDays).isAfter(dd.toLocaleDateString());

  const handleOpenImageViewer = (e) => {
    SetSelectedImage(e.target.src);
    setIsOpen(true);
  };

  
  const handleCloseImageViewer = () => {
    setIsOpen(false);
  };

  const user = useSelector(getUserContextData);

  const handleCloseAppealCitationModal = () => {
    setCount(0)
    setIsOpenAppealCitationModal(false);
  };

  const handlePdfView = () => {
    const detailsObject = {
      //name: citationDetailState && citationDetailState.userName,
      name: user && user?.user?.userName,
      citationId: params && params.citationId,
    };
    if (citationDetailState.payment) {
      dispatch(
        getDriverCitationPDFStatesUnpaid(detailsObject && detailsObject)
      );
    } else {
      dispatch(getDriverCitationPDFStates(detailsObject && detailsObject));
    }
  };
  const handleCloseAppealedCitationModal = () => {
    setIsOpenAppealedCitationModal(false);
  };

  const handleOpenAppealCitationModal = () => {
    if (appealCitationStatus) {
      setIsOpenAppealCitationModal(true);
      setIsOpenAppealedCitationModal(false);
    } else {
      setIsOpenAppealCitationModal(false);
      setIsOpenAppealedCitationModal(true);
    }
  };
  const handleOpenAppealedCitation = () => {
    setIsOpenAppealCitationModal(true);
  };
  const handleOpenAppealCitation = () => {
    setCount(1)
    setIsOpenAppealCitationModal(true);
  };
  const handlePayCition = () => {
    // history.push(RouteService.payCitationForm(customerName));
    history.push({
      pathname: RouteService.payCitationForm(customerName),
      state: {
        citationDetailState: citationDetailState,
      },
    });
  };

  React.useEffect(() => {
    dispatch(getStates(userParams.customer));
    if (customer) {
      dispatch(getCitationDetailsPageEditorDataAction(customer));
    }
  }, [customer]);

  useEffect(() => {
    dispatch(getCutationDurationDay(customer));
    dispatch(
      getCitation({
        ...params,
      })
    );
  }, [customerName]);
  if (Object.keys(citationDetailState).length < 1) {
    return (
      <div className={classes.content}>
        <Grid item>Not Found</Grid>
      </div>
    );
  }

  const d = new Date();
  const fineDueDate =
    new Date(citationDetailState?.fineDueDate).toLocaleDateString() || "n/a";
  const comparedate = moment(fineDueDate).isAfter(d.toLocaleDateString());
  const compareDiscountDays = moment(citationDetailState?.issueDate).add(citationDetailState?.type?.discountDays).isBefore(citationDetailState?.fineDueDate);

  const totalDiscountValue =
    Number(citationDetailState?.fine) +
    Number(citationDetailState?.fee) -
    Number(citationDetailState?.earlyPayTotal || 0);

  const capitalize = (str) => {
    var splitStr = str.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(" ");
  };

let fdf =(
  Number(citationDetailState?.fine) +
  Number(citationDetailState?.fee) +
  Number(citationDetailState?.lateFee || (0).toFixed(2))
)?.toFixed(2)

  const expDate = moment(citationDetailState?.fineDueDate)?.format("MM/DD/YYYY")
  var currentdate = new Date().toLocaleDateString(); 

  // const matchDate = () => {
  //   if(expDate == currentdate){
  //     return 'true'
  //   }else{
  //     return 'false'
  //   }
  // }

  // useEffect(() => {
  //   matchDate();
  // },[])

  return (
    <>
      <div className="page-wrapper">
        <Container maxWidth={"xl"} className="citation-footer-gap">
          <div>
            {citationDetailEditorData && citationDetailEditorData ? (
              <div
                className="ql-editor"
                style={{ color: "black" }}
                dangerouslySetInnerHTML={{ __html: citationDetailEditorData }}
              />
            ) : (
              <Text variant="body1" gutterBottom></Text>
            )}
          </div>

          <CitationDetailsCard
            className={classes.bdrc}
            title={`Citation #${citationDetailState.id}`}
            variant="white"
            onPdfView={citationDetailState?.status === 'WARNING' || citationDetailState?.status === 'WAIVED' ? '' : handlePdfView}
            
            onMoney={citationDetailState?.status === 'WARNING' || citationDetailState?.status === 'WAIVED' || !credutCardValue?.includes("ONLINE_CC")  ? '' : () => {
              history.push({
              pathname: RouteService.payCitationForm(customerName),
              state: {
                citationDetailState: citationDetailState,
              },
            });
              // history.push(RouteService.payCitationForm(customerName));
            }}
            onTool={
              citationDetailState.appeal ? handleOpenAppealCitationModal : null
            }
          >
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xxl={4} xl={4} lg={4} md={5} sm={6} xs={12}>
                  <Text align="center">
                    <b className="font-b">Citation Detail</b>
                  </Text>
                  <Divider />
                  <div className={classes.row}>
                    <div className={classes.half}>
                      <Text align="right">
                        <b>Issued:</b>
                      </Text>
                    </div>
                    <div className={classes.half}>
                      <Text>
                        {new Date(
                          citationDetailState.issueDate
                        ).toLocaleDateString()}
                      </Text>
                    </div>
                  </div>
                  <div className={classes.row}>
                    <div className={classes.half}>
                      <Text align="right">
                        <b>Violation:</b>
                      </Text>
                    </div>
                    <div className={classes.half}>
                      <Text>{citationDetailState?.type?.name || ""}</Text>
                    </div>
                  </div>
                  <div className={classes.row}>
                    <div className={classes.half}>
                      <Text align="right">
                        <b>Citation Status:</b>
                      </Text>
                    </div>
                    <div className={classes.half}>
                      <Text>
                        {citationDetailState &&
                          citationDetailState?.status[0]?.toUpperCase() +
                            citationDetailState.status?.slice(1).toLowerCase()}
                      </Text>
                    </div>
                  </div>
                  <div className={classes.row}>
                    <div className={classes.half}>
                      <Text align="right">
                        <b>Location:</b>
                      </Text>
                    </div>
                    <div className={classes.half}>
                      <Text>{citationDetailState?.location?.name}</Text>
                    </div>
                  </div>
                  <div className={classes.row}>
                    <div className={classes.half}>
                      <Text align="right">
                        <b>Badge#:</b>
                      </Text>
                    </div>
                    <div className={classes.half}>
                      <Text>#{citationDetailState.issuedByBadge}</Text>
                    </div>
                  </div>
                  <div className={classes.row}>
                    <div className={classes.half}>
                      <Text align="right">
                        <b>License Plate #:</b>
                      </Text>
                    </div>
                    <div className={classes.half}>
                      <Text>
                        {citationDetailState.vehicle?.licensePlate?.number}
                      </Text>
                    </div>
                  </div>
                </Grid>
                <Grid item xxl={4} xl={4} lg={4} md={5} sm={6} xs={12}>
                  <Text align="center">
                    <b className="font-b">Fine Informations</b>
                  </Text>
                  <Divider />
                  <div className={classes.row}>
                    <div className={classes.half}>
                      <Text align="right">
                        <b>Fine Amount:</b>
                      </Text>
                    </div>
                    <div className={classes.half}>
                      <Text>${citationDetailState?.status === 'WARNING' || citationDetailState?.status === 'WAIVED' ? (0).toFixed(2) : (citationDetailState?.fine || 0)?.toFixed(2)}</Text>
                    </div>
                  </div>
                  <div className={classes.row}>
                    <div className={classes.half}>
                      <Text align="right">
                        <b>Fee:</b>
                      </Text>
                    </div>
                    <div className={classes.half}>
                      <Text>${citationDetailState?.status === 'WARNING' || citationDetailState?.status === 'WAIVED' ? (0).toFixed(2) : (citationDetailState?.fee || 0)?.toFixed(2)}</Text>
                    </div>
                  </div>
                  <div className={classes.row}>
                    <div className={classes.half}>
                      <Text align="right">
                        <b>Due Date:</b>
                      </Text>
                    </div>
                    <div className={classes.half}>
                      <Text>
                        {!citationDetailState.fineDueDate
                          ? "N/A"
                          : new Date(
                              citationDetailState.fineDueDate
                            ).toLocaleDateString()}
                      </Text>
                    </div>
                  </div>
                  <div className={classes.row}>
                    <div className={classes.half}>
                      <Text align="right">
                        <b>Late Fee:</b>
                      </Text>
                    </div>
                    <div className={classes.half}>
                      <Text>
                        {/* ${citationDetailState?.status === 'WARNING' || citationDetailState?.status === 'WAIVED' ? (0).toFixed(2) : (citationDetailState.type?.lateFeeValue || 0)?.toFixed(2)} */}
                        ${citationDetailState?.status === 'WARNING' || citationDetailState?.status === 'WAIVED' ? (0).toFixed(2) : (citationDetailState?.lateFee || 0)?.toFixed(2)}
                      </Text>
                    </div>
                  </div>
                  <div className={classes.row}>
                    <div className={classes.half}>
                      <Text align="right">
                        <b>Total:</b>
                      </Text>
                    </div>
                    <div className={classes.half}>
                      <Text>
                        $
                        {citationDetailState?.status === 'WARNING' || citationDetailState?.status === 'WAIVED' ? (0).toFixed(2) :
                          comparedate || !citationDetailState?.fineDueDate
                          ? (compareDiscountDays ? (totalDiscountValue)?.toFixed(2) :(
                              Number(citationDetailState?.fine) +
                              Number(citationDetailState?.fee)
                            )?.toFixed(2))
                          : (
                              Number(citationDetailState?.fine) +
                              Number(citationDetailState?.fee) +
                              Number(citationDetailState?.lateFee || 0)
                            )?.toFixed(2)}
                        {/* {Number(citationDetailState?.type?.fine) +
                        Number(citationDetailState?.type?.fee) +
                        Number(citationDetailState.type?.lateFeeValue)} */}
                      </Text>
                    </div>
                  </div>
                  <div className={classes.row}>
                    <div className={classes.half}>
                      <Text align="right">
                        <b>Payment Status:</b>
                      </Text>
                    </div>
                    <div className={classes.half}>
                      <Text>
                        {/* {citationDetailState.payment ? "Paid" : "Unpaid"} */}
                        {citationDetailState?.payment?.reversedDate ? 'Unpaid' :
                        citationDetailState?.payment ? "Paid" : "Unpaid"}
                      </Text>
                    </div>
                  </div>
                  <div className={classes.row}>
                    <div className={classes.half}>
                      <Text align="right">
                        <b>Appeal Status:</b>
                      </Text>
                    </div>
                    <div className={classes.half}>
                      <Text>
                        {capitalize(
                          citationDetailState &&
                            citationDetailState?.appealsStatus?.replaceAll(
                              "_",
                              " "
                            )
                        ) || "N/A"}
                      </Text>
                    </div>
                  </div>
                </Grid>
                <Grid item xxl={4} xl={4} lg={4} md={5} sm={6} xs={12}>
                  <Text align="center">
                    <b className="font-b">Citation Images</b>
                  </Text>
                  <Divider />
                  {!citationDurationData?.portalCitationPhotos ? 
                  "" :
                  <Grid
                    container
                    item
                    xs={12}
                    spacing={1}
                    className={classes.spaceTop}
                  >
                    {citationDetailState.imageEntities.map((item) => {
                      return (
                        <Grid
                          item
                          xxl={4}
                          //{citationDetailState.imageEntities.length < 2 ? 12 : citationDetailState.imageEntities.length < 3 ? 6 : 12} xl={citationDetailState.imageEntities.length < 2 ? 12 : citationDetailState.imageEntities.length < 3 ? 6 : 12} lg={citationDetailState.imageEntities.length < 2 ? 12 : citationDetailState.imageEntities.length < 3 ? 6 : 12}
                          md={4}
                          sm={4}
                          xs={4}
                          lg={4}
                          className={classes.item}
                        >
                          <img
                            className={classes.img}
                            src={getConfig.baseUrl + item.uri}
                            onClick={handleOpenImageViewer}
                          />
                        </Grid>
                      );
                    })}
                    {citationDetailState.imageEntities.length > 6 ? (
                      <Grid xs={12}>
                        <Text
                          align="center"
                          color="primary"
                          className={classes.pointer}
                        >
                          View All
                        </Text>
                      </Grid>
                    ) : (
                      ""
                    )}
                  </Grid> }
                </Grid>
              </Grid>
            </CardContent>
          </CitationDetailsCard>
          {citationDetailState.payment ? (
            ""
          ) : (
            <Grid
              container
              xs={12}
              justify="center"
              className={classes.spaceTop}
            >
            {credutCardValue?.includes("ONLINE_CC") ? 
            <Button
                variant="contained"
                color="primary"
                onClick={handlePayCition}
                disabled={
                  (citationDetailState.status == "WARNING" || citationDetailState.status == "WAIVED") ? true : false
                }
              >
                Pay Citation
              </Button> : "" }
            </Grid>
          )}
      
          { 
            citationDurationData?.allowAppeals && compareDurationDate &&
               citationDetailState?.appealsStatus === "NOT_APPEALED" ? (
            <Grid
              container
              xs={12}
              justify="center"
              className={classes.spaceTop}
            >
              <Button
                variant="contained"
                color="primary"
                className="citation-btn"
                onClick={handleOpenAppealCitation}
                disabled={
                  (citationDetailState.status == "WARNING" || citationDetailState.status=="WAIVED") ? true : false || count == 1
                }
              >
                Appeal Citation
              </Button>
            </Grid>
          ) : (
            ""
          )}
        </Container>
      </div>
      <AppealCitationModal
        isOpenAppealCitationModal={isOpenAppealCitationModal}
        citationDetailState={citationDetailState}
        handleCloseAppealCitationModal={handleCloseAppealCitationModal}
        y
        {...params}
      />
      <AppealedCitationModal
        isOpenAppealedCitationModal={isOpenAppealedCitationModal}
        handleCloseAppealedCitationModal={handleCloseAppealedCitationModal}
        citationDetailState={citationDetailState}
      />
      <ImageViewer
        isOpen={isOpen}
        srcImage={selectedImage}
        handleClose={handleCloseImageViewer}
      />
    </>
  );
};

export default CitationDetailsPage;
